<template>
  <component
    :aria-labelledby="'droppable-assistive-text-' + droppableId"
    :is="tag"
    :class="cssClasses"
    v-bind="attributeBindings"
    v-on="$listeners"
  >
    <slot></slot>
    <span
      v-if="assistiveText"
      :id="'droppable-assistive-text-' + droppableId"
      class="comet-screenreader-only"
      >{{ `Select dropzone, ${assistiveText}` }}</span
    >
  </component>
</template>

<script>
import DroppableMixin from '../mixins/DroppableMixin';

export default {
  name: 'Droppable',
  mixins: [DroppableMixin],
};
</script>
